import "./Badge.css";

export function Badge({ children }) {
    return <span className="badge mono">{children}</span>;
}
